import React,{ useContext } from 'react'

import MyOpenDataContext from '../context/OpenDataContext';
import Loading from './Loading';

const ControlOpenData = () => {
    const { getRequests, loading, useCounter } = useContext(MyOpenDataContext);
    const { count, isLoading, isError } = useCounter();
    
    return (
        <div className='grid grid-cols-1 2md:grid-cols-2 place-items-center h-full font-mono space-y-4 animation-appear-top-center'>
            {isLoading ? <Loading isLoading={true} /> : isError ? <h1 className='px-4 text-lg text-center w-full'>{count}</h1> : (
                <div className='flex flex-col items-center justify-center gap-8 w-full px-4'>
                    <p className='text-lg text-justify w-full'>Hasta el momento,</p>
                    <p className='text-9xl font-bold w-full text-center'>{count}</p>
                    <p className='text-lg text-justify w-full'>personas han solicitado acceso a los datos abiertos de la Dirección de Gestión Catastral de Neiva.</p>
                </div>)}
            <div className='flex flex-col items-center justify-center gap-8 w-full px-4'>
                <p className='text-lg text-justify w-full'>Click en descargar para ver el registro:</p>
                
                {loading ? <Loading isLoading={loading} /> : (
                    <button onClick={() => getRequests()} className='relative flex flex-row group items-center justify-between w-[45%] 2md:w-[70%] lg:w-[50%] text-md border-2 border-green-400 hover:text-white transition-all duration-700 rounded-full overflow-hidden' >
                    <div className='absolute top-0 left-0 w-0 h-full group-hover:w-full bg-green-400 transition-all duration-700' />
                    <div className='rounded-full border-2 border-green-400 bg-green-400 w-auto m-1 z-10'>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1" stroke="white" className="w-8 h-8">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 13.5L12 21m0 0l-7.5-7.5M12 21V3" />
                        </svg>
                    </div>
                    <span className='w-full z-10'>Descargar</span>
                  </button>
                )}
            </div>
        </div>
    );
}
 
export default ControlOpenData;